import React from 'react';
import {TextField} from '@mui/material';
import RTLContainer from "@/core/general/rtlContainer.component";

interface SearchFiledProps {
  searchText: string;
  type: string;
  searchTag: string;
  onChangeText: any;
}

export const SearchField: React.FC<SearchFiledProps> = (props) => {
  return (
    <RTLContainer className="totalCenter py-2">
      <TextField
        autoComplete="off"
        value={props.searchText}
        type={props.type}
        onChange={props.onChangeText}
        className="searchBox mb-2 mt-1"
        label={props.searchTag}
        placeholder={props.searchTag}
        variant={'outlined'}
        sx={{
            // Apply styles to the root element of the outlined input
            '& .MuiOutlinedInput-root': {
                // Default/regular state
                '& fieldset': {
                    borderColor: 'var(--theme-color-blue-light)',
                },
                // Hover state
                '&:hover fieldset': {
                    borderColor: 'var(--theme-color-blue)',
                },
                // Focused state
                '&.Mui-focused fieldset': {
                    borderColor: 'var(--theme-color-blue)',
                },
            },
        }}
      />
    </RTLContainer>
  );
};
